import { ViewPortSizeContextProvider as BriqCommonViewPortSizeContextProvider } from '@briq/shared'

export type ViewportDimensions = BriqCommonViewPortSizeContextProvider.ViewportDimensions

export const ViewportSizeContext = BriqCommonViewPortSizeContextProvider.ViewportSizeContext

export const ViewportSizeContextProvider = BriqCommonViewPortSizeContextProvider.ViewportSizeContextProvider

export const ViewportSizeContextConsumer = BriqCommonViewPortSizeContextProvider.ViewportSizeContextConsumer
